export const fiat = [
    'ZAR',
    'GBP',
    'USD',
    'EUR',
    'CHF',
    'JPY',
    'KRW'
]

export const isFiatCurrency = (code: string) => fiat.includes(code?.toUpperCase())

const defaultExport = {
    fiat,
    isFiatCurrency
}

export default defaultExport;